"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const OperationalContext_1 = __importDefault(require("../OperationalContext/OperationalContext"));
const utils_1 = require("../utils");
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("a")(({ theme }) => ({
    color: theme.color.primary,
    label: "breadcrumb",
    "&:hover": Object.assign({}, utils_1.inputFocus({ theme })),
    "&:focus": Object.assign({}, utils_1.inputFocus({ theme })),
    "& > span": {
        outline: "none",
    },
}));
const Breadcrumb = (_a) => {
    var { to, icon: Icon, onClick } = _a, props = __rest(_a, ["to", "icon", "onClick"]);
    return (React.createElement(OperationalContext_1.default, null, ctx => (React.createElement(Container, Object.assign({}, props, { tabIndex: 0, href: to, onClick: (ev) => {
            if (onClick) {
                onClick(ev);
            }
            if (!utils_1.isModifiedEvent(ev) && ctx.pushState && to && !utils_1.isOutsideLink(to)) {
                ev.preventDefault();
                ctx.pushState(to);
            }
        } }),
        Icon && props.iconLeft && React.createElement(Icon, { size: 12, left: true }),
        React.createElement("span", null, props.children),
        Icon && !props.iconLeft && React.createElement(Icon, { size: 12, right: true })))));
};
exports.default = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map